<template>
  <div class="mt-3">
    <div class="mb-3">
      ***{{ text('context_info.EDIT_HERO.equipment.title') }}***
    </div>
    <p>
      {{ text('context_info.EDIT_HERO.equipment.p1') }}
    </p>
    <p>
      {{ text('context_info.EDIT_HERO.equipment.p2') }}
    </p>
  </div>

  <hr />

  <div class="mt-3">
    <div class="mb-3">
      ***{{ text('context_info.EDIT_HERO.ai_settings.title') }}***
    </div>
    <p>
      <span class="font-bold">{{ text('ui.ai_roles.dps_close') }} - </span>
      <span>
        {{ text('context_info.EDIT_HERO.ai_settings.dps_close') }}
      </span>
    </p>
    <p>
      <span class="font-bold">{{ text('ui.ai_roles.dps_ranged') }} - </span>
      <span>
        {{ text('context_info.EDIT_HERO.ai_settings.dps_ranged') }}
      </span>
    </p>
    <p>
      <span class="font-bold">{{ text('ui.ai_roles.tank') }} - </span>
      <span>
        {{ text('context_info.EDIT_HERO.ai_settings.tank') }}
      </span>
    </p>
    <p>
      <span class="font-bold">{{ text('ui.ai_roles.interference') }} - </span>
      <span>
        {{ text('context_info.EDIT_HERO.ai_settings.interference') }}
      </span>
    </p>
    <p>
      <span class="font-bold">{{ text('ui.ai_roles.support') }} - </span>
      <span>
        {{ text('context_info.EDIT_HERO.ai_settings.support') }}
      </span>
    </p>
  </div>
  <hr />
  <p class="mt-3">
    <span class="font-bold">{{ text('ui.affinities') }} - </span>
    <span>{{ text('context_info.EDIT_HERO.affinities') }}</span>
  </p>
  <hr />
  <p class="mt-3">
    <span class="text-cyan-400"
      >***{{ text('context_info.tip_for_beginners') }}***
    </span>
    <span>{{ text('context_info.EDIT_HERO.beginner_tip') }}</span>
  </p>
</template>

<script setup>
import text from '~/text';
</script>
